// extracted by mini-css-extract-plugin
export var borderRadius = "_b5-4";
export var large = "_b5-3";
export var logoContainer = "_b5-0";
export var nameLogo = "_b5-2";
export var small = "_b5-1";